import React, { ReactText, ReactNode } from 'react'
import Box from 'shared/components/Box'
import styled from 'styled-components'

type ParticipantInfoProps = {
  id?: string
  label: string | ReactNode
  value: any
}

const ParticipantInfo: React.FC<ParticipantInfoProps> = props => {
  const { id, label, value } = props

  return (
    <ParticipantInfoContainer id={id && id}>
      <InfoLabel id={id && `${id}__label`}>{label}</InfoLabel>
      <InfoValue id={id && `${id}__value`}>{value !== '' ? value : '-'}</InfoValue>
    </ParticipantInfoContainer>
  )
}

const ParticipantInfoContainer = styled(Box)`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 16px;
`

const InfoLabel = styled(Box)`
  font-weight: bold;
  line-height: 19px;
  margin-bottom: 10px;
`

const InfoValue = styled(Box)`
  line-height: 22px;
`

export default ParticipantInfo
